<template>
  <el-dialog
    :visible="true"
    :before-close="handleClose"
    :title="$t('报警阈值设置')"
    width="1200px"
    class="mn606-alarm-threshold-settings"
    top="10vh"
    v-loading="loading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
    element-loading-text="Loading"
  >
    <div class="mn606-alarm-threshold-settings_content scrollbar-thin">
      <el-table :data="tableConfig.data" border>
        <template v-for="col in tableConfig.thead">
          <CustomColumn :col="col" :key="col.code" />
        </template>

        <el-table-column label="操作" width="180" header-align="center" align="center">
          <template #default="{ row }">
            <!-- <template #default="{ row, $index }"> -->
            <!-- <el-button size="mini" type="primary" @click="reset($index)">
              {{ $t('重置') }}
            </el-button> -->
            <el-button size="mini" type="primary" @click="save(row)" :loading="saveLoading">
              {{ $t('保存') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
import CustomColumn from '../components/custom-column.vue';

import { awaitTo } from '@/utils/utils';
import { getMN606SensroAlarmThresh, setMN606SensroAlarmThresh } from '@/api/deviceSetting';
import { cloneDeep } from 'lodash';
import { isEmpty } from '@/utils/is';

export default {
  components: {
    CustomColumn
  },
  props: {
    sn: {
      type: String,
      default: ''
    },
    container: {
      type: HTMLElement,
      default: () => document.body
    }
  },
  data() {
    return {
      i18nPath: 'part',
      loading: false,
      saveLoading: false,
      rawData: [],
      tableConfig: {
        data: [],
        thead: [
          { label: '传感器名称', prop: 'sensorName' },
          { label: '高报警', prop: 'threshHi', editable: true },
          { label: '低报警', prop: 'threshLo', editable: true },
          { label: '预报警', prop: 'threshStel', editable: true },
          { label: '8小时报警', prop: 'threshTwa', editable: true },
          { label: '极大值报警', prop: 'threshMac', editable: true }
        ]
      }
    };
  },
  methods: {
    async getThresold() {
      try {
        this.loading = true;

        const [err, res] = await awaitTo(getMN606SensroAlarmThresh(this.sn));

        if (err) {
          this.$message({
            type: 'error',
            message: this.$t('获取报警阈值失败')
          });

          this.handleClose();

          return console.log(err);
        }

        if (isEmpty(res.data)) {
          this.handleClose();

          return;
        }

        this.rawData.splice(0, Infinity, ...cloneDeep(res.data));
        this.tableConfig.data.splice(0, Infinity, ...res.data);
      } catch (error) {
        this.handleClose();

        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    reset(index) {
      Object.assign(this.tableConfig.data[index], this.rawData[index]);
    },
    async save(row) {
      this.saveLoading = true;

      const model = { ...row, sn: this.sn };

      console.log(model);

      const [err, _res] = await awaitTo(setMN606SensroAlarmThresh(model));

      this.saveLoading = false;

      if (err) {
        this.$message({
          type: 'error',
          message: this.$t('保存失败')
        });
        return;
      }

      this.$message({
        type: 'success',
        message: this.$t('保存成功')
      });
    },
    handleClose(done) {
      this.$destroy();
      done?.();
    }
  },
  mounted() {
    document.body.appendChild(this.$el);

    this.getThresold();
  },
  destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};
</script>

<style lang="scss">
.mn606-alarm-threshold-settings {
  box-sizing: border-box;

  &_content {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .el-dialog {
    height: calc(100vh - 20vh);

    max-width: 85vw;

    &__body {
      height: calc(100% - 55px);
      box-sizing: border-box;
    }

    .action-wrap {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
